import { useState, useEffect, Fragment } from "react";
import {
    Grid,
    Box,
    Typography,
    List,
    ListItem,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormControl,
    TextField,
    Autocomplete,
    IconButton,
} from "@material-ui/core";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Header from "../../components/GenericHeader/Header";
import MenuProfile from "../../components/Menu/MenuProfile";
import CustomButton from "../../controls/Button/CustomButton";
import useStyles from "../../assets/styles/styles";
import { useHistory, useLocation } from "react-router";
import ModalActivities from "../../components/DialogActivities/ModalActivities";
import { useDispatch } from "react-redux";
import { postAddEvolution, postAddVitalSigns, postAddLaboratory, postAddAnthropometry } from "../../redux/actions/appointmentsActions";
import { showErrorMessageModalAccordion } from "../../utils/utilsFunctions";
import ArticleIcon from '@mui/icons-material/Article';
import VitalSignInput from "./VitalSignInput";
import ScienceIcon from '@material-ui/icons/Science';
import FavoriteIcon from "@material-ui/icons/Favorite";
import AnthropometryInput from "./AnthropometryInput";
import MonitorWeightOutlinedIcon from '@material-ui/icons/MonitorWeightOutlined';


const EvolutionStep1 = () => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const { patientData, especialidad, selectedDay, closestTurn } = location.state || {};
    const [formData, setFormData] = useState({
        appointmentDate: '',
        appointmentTime: '',
        problem: '',
        observations: '',
        bloodPressureSystolic: '',
        bloodPressureMean: '',
        respiratoryRate: '',
        heartRate: '',
        temperature: '',
        bloodPressureDiastolic: '',
        glucose: '',
        weight: '',
        height: '',
        headCircumference: '',
        chestCircumference: '',
        armCircumference: '',
        tricepsSkinfold: '',
        subscapularSkinfold: '',
        waistCircumference: '',
    });
    const [openModal, setOpenModal] = useState(false);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [error, setError] = useState({
        problem: false,
    });
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [expandedAccordion, setExpandedAccordion] = useState(false);
    const [errors, setErrors] = useState({
        bloodPressureSystolic: "",
        bloodPressureMean: "",
        respiratoryRate: "",
        heartRate: "",
        temperature: "",
        bloodPressureDiastolic: "",
        glucose: "",
        weight: "",
        height: "",
        headCircumference: "",
        chestCircumference: "",
        armCircumference: "",
        tricepsSkinfold: "",
        subscapularSkinfold: "",
        waistCircumference: "",
    });

    const mockProblems = [
        { code: "Z00.0", description: "Examen médico general" },
        { code: "I10", description: "Hipertensión esencial" },
        { code: "E11", description: "Diabetes mellitus tipo 2" },
        { code: "J06.9", description: "Infección aguda de las vías respiratorias superiores" },
        { code: "M79.3", description: "Paniculitis, no especificada" },
        { code: "K59.0", description: "Estreñimiento" },
        { code: "R50.9", description: "Fiebre, no especificada" },
        { code: "Z51.1", description: "Sesión de quimioterapia para neoplasia" }
    ];


    useEffect(() => {
        if (selectedDay && closestTurn?.agendaHoraHasta) {
            setFormData((prev) => ({
                ...prev,
                appointmentDate: selectedDay,
                appointmentTime: closestTurn?.agendaHoraHasta,
            }));
        } else {
            const now = new Date();
            setFormData((prev) => ({
                ...prev,
                appointmentDate: now.toISOString().split('T')[0],
                appointmentTime: now.toTimeString().split(' ')[0].substring(0, 5),
            }));
        }
    }, [selectedDay, especialidad]);


    const handleCancel = () => {
        setOpenModal(true);
    };


    const handleClickCancelAppointment = () => {
        setOpenModal(false);
        history.goBack();
    };


    const handleSubmit = () => {
        const formDataToSubmit = {
            Especialidad: especialidad,
            FechaTurno: formData.appointmentDate,
            HoraTurno: formData.appointmentTime,
            Problema: formData.problem?.description || "",
            Observaciones: formData.observations,
        };

        const vitalSignsData = {
            vitalSigns: [
                {
                    nombreCampo: "Presión Sistólica",
                    valor: formData.bloodPressureSystolic,
                    unidadMedida: "mm Hg",
                    icono: "import AddCircleIcon from '@mui/icons-material/AddCircle';",
                },
                {
                    nombreCampo: "Presión Media",
                    valor: formData.bloodPressureMean,
                    unidadMedida: "mm Hg",
                    icono: "",
                },
                {
                    nombreCampo: "Frecuencia Respiratoria",
                    valor: formData.respiratoryRate,
                    unidadMedida: "RPM",
                    icono: "",
                },
                {
                    nombreCampo: "Frecuencia Cardíaca",
                    valor: formData.heartRate,
                    unidadMedida: "LPM",
                    icono: "",
                },
                {
                    nombreCampo: "Temperatura",
                    valor: formData.temperature,
                    unidadMedida: "°C",
                    icono: "",
                },
                {
                    nombreCampo: "Presión Diastólica",
                    valor: formData.bloodPressureDiastolic,
                    unidadMedida: "mm Hg",
                    icono: "",
                },
            ]
        };

        const laboratoryData = {
            nombreCampo: "Glucemia",
            valor: formData.glucose,
            unidadMedida: "mg/dL",
            icono: ""
        };

        const antropometryData = {
            antropometry: [
                {
                    nombreCampo: "PESO",
                    valor: formData.weight,
                    unidadMedida: "kg",
                    icono: "",
                },
                {
                    nombreCampo: "TALLA",
                    valor: formData.height,
                    unidadMedida: "cm",
                    icono: "",
                },
                {
                    nombreCampo: "PERIMETRO CEFÁLICO",
                    valor: formData.headCircumference,
                    unidadMedida: "cm",
                    icono: "",
                },
                {
                    nombreCampo: "PERIMETRO TORÁCICO",
                    valor: formData.chestCircumference,
                    unidadMedida: "cm",
                    icono: "",
                },
                {
                    nombreCampo: "PERIMETRO BRAQUIAL",
                    valor: formData.armCircumference,
                    unidadMedida: "cm",
                    icono: "",
                },
                {
                    nombreCampo: "PLIEGUE TRICIPITAL",
                    valor: formData.tricepsSkinfold,
                    unidadMedida: "mm",
                    icono: "",
                },
                {
                    nombreCampo: "PLIEGUE ESCAPULAR",
                    valor: formData.subscapularSkinfold,
                    unidadMedida: "mm",
                    icono: "",
                },
                {
                    nombreCampo: "PERIMETRO DE CINTURA",
                    valor: formData.waistCircumference,
                    unidadMedida: "cm",
                    icono: "",
                },
            ],
        };

        dispatch(postAddEvolution(formDataToSubmit));
        dispatch(postAddVitalSigns(vitalSignsData));
        dispatch(postAddLaboratory(laboratoryData));
        dispatch(postAddAnthropometry(antropometryData));
    };


    const handleAccept = () => {
        setOpenModalConfirm(false);
        handleSubmit();
        history.goBack();
    };


    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedAccordion(isExpanded ? panel : false);
    };


    const handleConfirm = () => {
        let requiredFields = [];
        let hasErrors = false;

        if (!formData.problem) {
            setError((prev) => ({ ...prev, problem: true }));
            requiredFields.push("Información de la consulta");

            setExpandedAccordion("consulta");
            hasErrors = true;
        } else {
            setError((prev) => ({ ...prev, problem: false }));
        }

        const vitalSignsErrors = {
            bloodPressureSystolic: validateRange(formData.bloodPressureSystolic, 90, 140),
            bloodPressureMean: validateRange(formData.bloodPressureMean, 70, 105),
            temperature: validateRange(formData.temperature, 36, 37.5),
            heartRate: validateRange(formData.heartRate, 60, 100),
            respiratoryRate: validateRange(formData.respiratoryRate, 12, 20),
            bloodPressureDiastolic: validateRange(formData.bloodPressureDiastolic, 60, 90),
        };

        const laboratoryErrors = {
            glucose: validateRange(formData.glucose, 70, 120),
        };

        const antropometryErrors = {
            weight: validateRange(formData.weight, 30, 200),
            height: validateRange(formData.height, 50, 250),
            headCircumference: validateRange(formData.headCircumference, 30, 60),
            chestCircumference: validateRange(formData.chestCircumference, 50, 120),
            armCircumference: validateRange(formData.armCircumference, 15, 50),
            tricepsSkinfold: validateRange(formData.tricepsSkinfold, 5, 50),
            subscapularSkinfold: validateRange(formData.subscapularSkinfold, 5, 50),
            waistCircumference: validateRange(formData.waistCircumference, 50, 150),
        };

        setErrors((prev) => ({ ...prev, ...vitalSignsErrors, ...laboratoryErrors, ...antropometryErrors }));

        if (Object.values(vitalSignsErrors).some((error) => error)) {
            requiredFields.push("Signos vitales");
            setExpandedAccordion("signos vitales");
            hasErrors = true;
        }

        if (Object.values(laboratoryErrors).some((error) => error)) {
            requiredFields.push("Laboratorio");
            setExpandedAccordion("laboratorio");
            hasErrors = true;
        }

        if (Object.values(antropometryErrors).some((error) => error)) {
            requiredFields.push("Antropometría");
            setExpandedAccordion("antropometria");
            hasErrors = true;
        }

        if (hasErrors) {
            const message = `Completar los campos obligatorios de las secciones: ${requiredFields.join(", ")}.`;
            setErrorMessage(message);
            setOpenError(true);
            return;
        }
        setOpenModalConfirm(true);
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    function validateRange(value, min, max) {
        if (value === "" || value === null || value === undefined)
            return "Campo requerido";

        const num = Number(value);

        if (isNaN(num))
            return "Valor inválido";

        if (num < min || num > max)
            return `Debe estar entre ${min} y ${max}`;

        return false;
    }




    return (
        <>
            <MenuProfile />
            <Box className={classes.txtTitleMedicalAgenda}>
                <Header title="Nueva Evolución" />
            </Box>
            <Box className={classes.boxHeadermedicalCalendar}>
                <IconButton onClick={() => history.goBack()}>
                    <ArrowBackIcon className={classes.iconFilter} />
                </IconButton>
            </Box>
            <Box className={classes.contentBox}>
                <Box className={classes.medicalInitialEvolutionAccordion}>
                    <Accordion defaultExpanded={true}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box display="flex" alignItems="center" gap={1}>
                                <AccountBoxIcon className={classes.menuButtonRight} />
                                <Typography> Datos del Afiliado </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List>
                                <Fragment>
                                    <ListItem>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Typography className={classes.textTitleMedicalHistory}>
                                                    PACIENTE
                                                </Typography>
                                                <Typography className={classes.textDescripctionMedicalHistory}>
                                                    {patientData?.datosAfiliado?.nombre || 'Juan Pérez'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography className={classes.textTitleMedicalHistory}>
                                                    DNI | CREDENCIAL
                                                </Typography>
                                                <Typography className={classes.textDescripctionMedicalHistory}>
                                                    {patientData?.datosAfiliado?.dni || '30123456'} | {'OSLP ' + (patientData?.datosAfiliado?.credencial?.numero || '3344 5556 7765')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </ListItem>
                                </Fragment>
                            </List>
                        </AccordionDetails>
                    </Accordion>
                </Box>

                <Box className={classes.medicalInitialEvolutionForm}>
                    <Accordion expanded={expandedAccordion === "consulta"} onChange={handleAccordionChange("consulta")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box display="flex" alignItems="center" gap={1}>
                                <ArticleIcon className={classes.menuButtonRight} />
                                <Typography> Información de la Consulta </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={7}>
                                    <FormControl fullWidth required>
                                        <TextField
                                            value={especialidad}
                                            label="Tipo de prestación *"
                                            variant="outlined"
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        label="Fecha del turno"
                                        value={formatDate(formData.appointmentDate)}
                                        onChange={(e) => {
                                            const [day, month, year] = e.target.value.split('/');
                                            const formattedDate = `${year}-${month}-${day}`;
                                            setFormData({ ...formData, appointmentDate: formattedDate });
                                        }}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        value={formData.appointmentTime}
                                        onChange={(e) => setFormData({ ...formData, appointmentTime: e.target.value })}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} md={7}>
                                    {error.problem && (
                                        <Typography color="error" variant="body2">
                                            Campo obligatorio *.
                                        </Typography>
                                    )}
                                    <Autocomplete
                                        options={mockProblems}
                                        getOptionLabel={(option) => option.description}
                                        disableClearable
                                        onChange={(event, newValue) => {
                                            setFormData({ ...formData, problem: newValue });
                                            setError((prev) => ({ ...prev, problem: false }));
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Problema / Procedimiento"
                                                required
                                                InputProps={{
                                                    ...params.InputProps,
                                                    classes: { input: classes.txtInputProcedure },
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={4}
                                        label="Notas Clínicas"
                                        value={formData.observations}
                                        onChange={(e) => setFormData({ ...formData, observations: e.target.value })}
                                        variant="outlined"
                                        placeholder="Escribe tu texto aqui"
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expandedAccordion === "signos vitales"} onChange={handleAccordionChange("signos vitales")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box display="flex" alignItems="center" gap={1}>
                                <FavoriteIcon className={classes.menuButtonRight} />
                                <Typography>Signos Vitales</Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={3} >
                                <VitalSignInput
                                    label="Presión Sistólica"
                                    value={formData.bloodPressureSystolic}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData({ ...formData, bloodPressureSystolic: value });
                                        setErrors((prev) => ({
                                            ...prev,
                                            problem: false,
                                            bloodPressureSystolic: validateRange(value, 90, 140),
                                        }));
                                    }}
                                    error={errors.bloodPressureSystolic || error.bloodPressureSystolic}
                                    errorMessage={errors.bloodPressureSystolic}
                                    unit="mm Hg"
                                />
                                <VitalSignInput
                                    label="Presión Media"
                                    value={formData.bloodPressureMean}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData({ ...formData, bloodPressureMean: value });
                                        setErrors((prev) => ({
                                            ...prev,
                                            problem: false,
                                            bloodPressureMean: validateRange(value, 70, 105),
                                        }));
                                    }}
                                    error={errors.bloodPressureMean}
                                    errorMessage={errors.bloodPressureMean}
                                    unit="mm Hg"
                                />
                                <VitalSignInput
                                    label="Fr.Respiratoria"
                                    value={formData.respiratoryRate}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData({ ...formData, respiratoryRate: value });
                                        setErrors((prev) => ({
                                            ...prev,
                                            problem: false,
                                            respiratoryRate: validateRange(value, 12, 20),
                                        }));
                                    }}
                                    error={errors.respiratoryRate}
                                    errorMessage={errors.respiratoryRate}
                                    unit="RPM"
                                />
                                <VitalSignInput
                                    label="Fr.Cardíaca"
                                    value={formData.heartRate}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData({ ...formData, heartRate: value });
                                        setErrors((prev) => ({
                                            ...prev,
                                            problem: false,
                                            heartRate: validateRange(value, 60, 100),
                                        }));
                                    }}
                                    error={errors.heartRate}
                                    errorMessage={errors.heartRate}
                                    unit="LPM"
                                />
                                <VitalSignInput
                                    label="Temperatura"
                                    value={formData.temperature}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData({ ...formData, temperature: value });
                                        setErrors((prev) => ({
                                            ...prev,
                                            problem: false,
                                            temperature: validateRange(value, 36, 37.5),
                                        }));
                                    }}
                                    error={errors.temperature}
                                    errorMessage={errors.temperature}
                                    unit="°C"
                                />
                                <VitalSignInput
                                    label="Presión Diastólica"
                                    value={formData.bloodPressureDiastolic}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData({ ...formData, bloodPressureDiastolic: value });
                                        setErrors((prev) => ({
                                            ...prev,
                                            problem: false,
                                            bloodPressureDiastolic: validateRange(value, 60, 90),
                                        }));
                                    }}
                                    error={errors.bloodPressureDiastolic}
                                    errorMessage={errors.bloodPressureDiastolic}
                                    unit="mm Hg"
                                />
                            </Grid>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expandedAccordion === "laboratorio"} onChange={handleAccordionChange("laboratorio")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box display="flex" alignItems="center" gap={1}>
                                <ScienceIcon className={classes.menuButtonRight} />
                                <Typography> Laboratorio </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={3} >
                                <Grid style={{ marginLeft: "20px" }} item xs={12} md={6}>
                                    <Typography className={classes.txtDescriptionVitalSignsForm}> Glucemia </Typography>
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <TextField
                                            value={formData.glucose}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setFormData({ ...formData, glucose: value });
                                                setErrors((prev) => ({
                                                    ...prev,
                                                    glucose: validateRange(value, 70, 125)
                                                }));
                                            }}
                                            variant="outlined"
                                            error={!!errors.glucose}
                                        />
                                        <Typography className={classes.txtDescriptionVitalSignsForm}> mg/dL </Typography>
                                    </Box>
                                    {errors.glucose && (
                                        <Typography variant="body2" color="error" className={classes.txtDescriptionVitalSignsError}>
                                            {errors.glucose}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expandedAccordion === "antropometria"} onChange={handleAccordionChange("antropometria")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box display="flex" alignItems="center" gap={1}>
                                <MonitorWeightOutlinedIcon className={classes.menuButtonRight} />
                                <Typography> Antropometría </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={3}>
                                <Grid item xs={6} md={3} >
                                    <AnthropometryInput
                                        label="PESO"
                                        value={formData.weight}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData({ ...formData, weight: value });
                                            setErrors((prev) => ({
                                                ...prev,
                                                weight: validateRange(value, 30, 200),
                                            }));
                                        }}
                                        error={errors.weight}
                                        errorMessage={errors.weight}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3} >
                                    <AnthropometryInput
                                        label="TALLA"
                                        value={formData.height}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData({ ...formData, height: value });
                                            setErrors((prev) => ({
                                                ...prev,
                                                height: validateRange(value, 50, 250),
                                            }));
                                        }}
                                        error={errors.height}
                                        errorMessage={errors.height}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3} >
                                    <AnthropometryInput
                                        label="PERIMETRO CEFÁLICO"
                                        value={formData.headCircumference}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData({ ...formData, headCircumference: value });
                                            setErrors((prev) => ({
                                                ...prev,
                                                headCircumference: validateRange(value, 30, 60),
                                            }));
                                        }}
                                        error={errors.headCircumference}
                                        errorMessage={errors.headCircumference}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3} >
                                    <AnthropometryInput
                                        label="PERIMETRO TORÁCICO"
                                        value={formData.chestCircumference}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData({ ...formData, chestCircumference: value });
                                            setErrors((prev) => ({
                                                ...prev,
                                                chestCircumference: validateRange(value, 50, 120),
                                            }));
                                        }}
                                        error={errors.chestCircumference}
                                        errorMessage={errors.chestCircumference}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3} >
                                    <AnthropometryInput
                                        label="PERIMETRO BRAQUIAL"
                                        value={formData.armCircumference}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData({ ...formData, armCircumference: value });
                                            setErrors((prev) => ({
                                                ...prev,
                                                armCircumference: validateRange(value, 15, 50),
                                            }));
                                        }}
                                        error={errors.armCircumference}
                                        errorMessage={errors.armCircumference}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3} >
                                    <AnthropometryInput
                                        label="PLIEGUE TRICIPITAL"
                                        value={formData.tricepsSkinfold}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData({ ...formData, tricepsSkinfold: value });
                                            setErrors((prev) => ({
                                                ...prev,
                                                tricepsSkinfold: validateRange(value, 5, 50),
                                            }));
                                        }}
                                        error={errors.tricepsSkinfold}
                                        errorMessage={errors.tricepsSkinfold}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3} >
                                    <AnthropometryInput
                                        label="PLIEGUE ESCAPULAR"
                                        value={formData.subscapularSkinfold}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData({ ...formData, subscapularSkinfold: value });
                                            setErrors((prev) => ({
                                                ...prev,
                                                subscapularSkinfold: validateRange(value, 5, 50),
                                            }));
                                        }}
                                        error={errors.subscapularSkinfold}
                                        errorMessage={errors.subscapularSkinfold}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3} >
                                    <AnthropometryInput
                                        label="PERIMETRO DE CINTURA"
                                        value={formData.waistCircumference}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData({ ...formData, waistCircumference: value });
                                            setErrors((prev) => ({
                                                ...prev,
                                                waistCircumference: validateRange(value, 50, 150),
                                            }));
                                        }}
                                        error={errors.waistCircumference}
                                        errorMessage={errors.waistCircumference}
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>

                    <Grid item xs={12} mb={2}>
                        <Box display="flex" justifyContent="center" mt={2} gap={2} >
                            <CustomButton
                                title="Cancelar"
                                onClick={handleCancel}
                                customClass={`${classes.fontBold} ${classes.whiteAndBlueBtn}`}
                            />
                            <CustomButton
                                title="Guardar"
                                onClick={handleConfirm}
                                customClass={`${classes.lightLinearGradient} ${classes.fontBold}`}
                            />
                        </Box>
                    </Grid>
                </Box>
            </Box>

            {openModal && (
                <ModalActivities
                    title="Cancelar evolucion"
                    description="¿Estás seguro que deseas cancelar la evolucion?"
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                    modalconfirm={true}
                    modalLogout={false}
                    buttonType="submit"
                    handleClick={handleClickCancelAppointment}
                />
            )}

            {openModalConfirm && (
                <ModalActivities
                    title="Confirmar evolucion"
                    description="¿Estás seguro que deseas realizar esta evolucion?"
                    open={openModalConfirm}
                    onClose={() => setOpenModalConfirm(false)}
                    modalconfirm={true}
                    modalLogout={false}
                    buttonType="submit"
                    handleClick={handleAccept}
                />
            )}
            {showErrorMessageModalAccordion(errorMessage, openError, setOpenError, classes.borderWhite, classes.contentDialogTitle)}
        </>
    );
};

export default EvolutionStep1;